import {
  resetDropdowns,
  showThankYouModal,
  INFUSION_LOCATOR,
  DTC_API_URL,
  DTC_EXTERNAL_KEY,
  API_KEY,
  getReferralSource
} from "./main";

export async function submitUpdateForm(form) {
  const nowIso = new Date().toISOString().replace(/\.\d{3}Z$/, "");
  const isDtc = form.id === "updates-form";

  const payload = isDtc
    ? {
        FirstName: document.getElementById("firstName").value.trim(),
        LastName: document.getElementById("lastName").value.trim(),
        Address1: document.getElementById("address1").value.trim(),
        Address2: document.getElementById("address2").value.trim(),
        City: document.getElementById("city").value.trim(),
        State: document.getElementById("state").value,
        Zip: document.getElementById("zip").value.trim(),
        PhoneNumber: document.getElementById("phone").value.trim(),
        EmailAddress: document.getElementById("email").value.trim(),
        Profession: document.getElementById("profession").value,
        OptInDate: nowIso,
        OriginSource: document.getElementById("form-origin-src").value,
        ReferralSource: getReferralSource(),
        CreateDate: nowIso,
        Status: "Active",
      }
    : {
        FirstName: document.getElementById("firstName-hcp").value.trim(),
        LastName: document.getElementById("lastName-hcp").value.trim(),
        Title: document.getElementById("title-hcp").value.trim(),
        EmailAddress: document.getElementById("email-hcp").value.trim(),
        Phone: document.getElementById("facility-phone-hcp").value.trim(),
        RequestType: document.getElementById("amr-facility-hcp").value,
        FacilityName: document.getElementById("facility-name-hcp").value.trim(),
        FacilityAddress1: document.getElementById("facility-address-1-hcp").value.trim(),
        FacilityAddress2: document.getElementById("facility-address-2-hcp").value.trim(),
        FacilityCity: document.getElementById("facility-city-hcp").value.trim(),
        FacilityState: document.getElementById("facility-state-hcp").value,
        FacilityZIPCode: document.getElementById("facility-zip-hcp").value.trim(),
        FacilityPhone: document.getElementById("facility-phone-hcp").value.trim(),
        FacilityWebsite: document.getElementById("facility-website-hcp").value.trim(),
        Lat: document.getElementById("facility-latitude-hcp").value,
        Lng: document.getElementById("facility-longitude-hcp").value,
        HealthCareProvider: true,
      };

  const apiUrl = isDtc ? DTC_API_URL : INFUSION_LOCATOR;
  const externalKey = isDtc ? DTC_EXTERNAL_KEY : "";

  try {
    const response = await fetch(
      `${apiUrl}?externalKey=${externalKey}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();

    if (response.ok) {
      form.reset();
      resetDropdowns();
      showThankYouModal();
    } else {
      alert(result.error || "Submission failed.");
    }
  } catch (err) {
    console.error(err);
    alert("Something went wrong.");
  }
}